import React from 'react';

const ProposalList = ({no,proposalInfo}) => {
    return (
        <div className="py-3 proposal-list">
                  <h5>{no+1} {proposalInfo?.title1}</h5>
            <p className="body-text ">{proposalInfo?.descript[0]?.text}</p>
        </div>
    );
};

export default ProposalList;